import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatDialog,
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NotifySlUsersBy } from '../../constants/KRollConstants';
import { KRollService } from '../../services/api-services/kroll.service';
import { ShippingService } from '../../services/api-services/shipping.service';
import { FormService } from '../../services/form.service';
import { HelperService } from '../../services/helper.service';
import { arrayMinLengthByKey } from '../../validator/form-validators.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';
import { Validators, AbstractControl } from '@angular/forms';
import { PreAssessmentService } from 'src/app/core/services/api-services/pre-assessments.service';
import { UserService } from '../../services/api-services/user.service';
import { AddReasonForTransferPrscription } from 'src/app/core/modals/add-reason-for-prscription-transfer/add-reason-for-prscription-transfer.component';
import { AddCourierForTransferPrscriptionComponent } from 'src/app/core/modals/add-courier-for-transfer-prscription/add-courier-for-transfer-prscription.component';
import { MatRadioButton } from '@angular/material/radio';
enum NotifyType {
  sms = 'sms',
  message = 'message',
  do_not = 'do_not',
}

@Component({
  selector: 'app-prescription-status-transfer',
  templateUrl: './prescription-status-transfer.component.html',
  styleUrls: ['./prescription-status-transfer.component.scss'],
})
export class TransferPrescriptionStatusComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  progress_spinner: boolean = true;
  isLoading: boolean = false;
  NotifyType = NotifyType;
  tenant: any = localStorage.getItem('tenant');
  payload: { NotifyUsers: boolean; NotifySlUsersBy: Array<number> } = {
    NotifyUsers: true,
    NotifySlUsersBy: [],
  };
  preSelectedStatuses = [
    'cancelled',
    'confirmed',
    'filled',
    'on hold',
    'pending',
    'received',
    'transferred out',
    'verification in progress',
    'transfer in progress',
    'transfer completed',
    'transfer initiated attempt1',
    'transfer initiated attempt2',
    'transfer initiated attempt3'
  ];
  //courierStatuses = ['confirmed', 'verification in progress', 'filled'];
  courierStatuses = ['no'];
  reasonStatuses = ['on hold', 'transferred out', 'cancelled', 'transfer delayed', 'pending info attempt1', 'pending info attempt2'];
  reasonList: any[] = [];
  courierList: any[] = [];
  rejectedReasonRequired: boolean = true;
  selectedStatus: any;
  isReasonStatus: boolean = false;
  isCourierStatus: boolean = false;
  showInternalNotes: boolean = false;
  isReasonLoaded: boolean = false;
  isMessageLoaded: boolean = true;
  isPatientMessage: boolean = true;
  statusMessage: any;
  constructor(
    public dialogRef: MatDialogRef<TransferPrescriptionStatusComponent>,
    public dialog: MatDialog,
    private fb: FormBuilder,
    public toast: ToastrService,
    public shippingService: ShippingService,
    public formService: FormService,
    public krollService: KRollService,
    public userService: UserService,
    public preAssessmentService: PreAssessmentService,
    public validationMessagesService: ValidationMessagesService,
    public helperService: HelperService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any
  ) { }

  ngOnInit(): void {
    this.selectedStatus = this.props.item.status;   
     if (Number.isInteger(this.selectedStatus)) {
      this.selectedStatus = this.props.item.statusMessage;
    }
    this.isCourierStatus = this.courierStatuses.includes(this.selectedStatus);
    this.isReasonStatus = this.reasonStatuses.includes(this.selectedStatus);

    this.initializeForm();
    this.reasonListForPrscriptionStatus();
    this.couriersListForPrscriptionStatus();
    this.getCustomeMessage();
    this.form.get('reason_id')?.valueChanges.subscribe((change: any) => {
      if (!this.isReasonStatus) {
        this.getCustomeMessage();
      }    
      if (change != null || change != undefined) {
        this.showInternalNotes = true;
        this.isMessageLoaded = false;
        this.onReasonChange();
      } else {
        this.showInternalNotes = false;
      }
      
    })
  }

  onCheckChange(event: MatCheckboxChange) {
    const customMessageControl = this.form.get('custom_message');
    if (customMessageControl) {
      if (event.checked) {
        this.addNotifyControl();
      } else {
        // Set custom_message control value to false
        customMessageControl.setValue(false);
        this.form.removeControl('NotifyUsersBy');
      }
    }
  }
  onCheckMessage(event: MatCheckboxChange) {
    const validators = this.getConditionalValidators(); // Get the updated validators
    this.form.controls['message'].setValidators(validators); // Set the validators for the 'message' control
    this.form.controls['message'].updateValueAndValidity(); // Update the value and validity of the control
  }

  initializeForm() {
    let { NotifyUsers } = this.payload;

    const isCustomMessageSelected = false;

    const rejectedReasonValidators = this.preSelectedStatuses.includes(
      this.selectedStatus
    )
      ? [Validators.required]
      : [Validators.nullValidator];

    this.form = this.fb.group({
      NotifyUsers: new FormControl(NotifyUsers),
      custom_message: new FormControl({ value: isCustomMessageSelected, disabled: this.isReasonStatus }),
      //RejectedReasonID: new FormControl("", rejectedReasonValidators),
      courier_id: new FormControl(
        '',
        this.isCourierStatus ? [Validators.required] : []
      ),
      reason_id: new FormControl(null, this.isReasonStatus ? [Validators.required] : []),
      message: new FormControl('', this.getConditionalValidators()),
      internal_notes: new FormControl(''),
      filled_status: new FormControl(null),
      NotifyUsersBy: this.fb.array([]),
      // disableSmsCheckbox: true

    });

    this.addNotifyControl();
  }

  isCustomMessageVisible(): boolean {
    return this.preSelectedStatuses.includes(this.props.item.statusMessage);
  }

  getConditionalValidators() {
    return (control: AbstractControl) => {
      if (
        this.form.get('custom_message')?.value &&
        this.form.get('NotifyUsers')?.value
      ) {
        return Validators.required(control);
      } else {
        return null; // If custom_message is unchecked, disable the validation.
      }
    };
  }

  get notifyByArray() {
    return this.form.get('NotifyUsersBy') as FormArray;
  }
  private addNotifyControl() {
    this.form.addControl(
      'NotifyUsersBy',
      this.fb.array([], arrayMinLengthByKey(1, 'isChecked'))
    );
    NotifySlUsersBy.forEach((x: any) => {
      this.notifyByArray.push(
        this.fb.group({
          id: new FormControl(x.id),
          value: new FormControl(x.value),
          isChecked: new FormControl(x.isChecked),
          disable: new FormControl(false),
        })
      );
    });
  }

  formSubmit() {
    if (this.isLoading) {
      return;
    }
    if (this.form.get('filled_status')?.value == null && this.selectedStatus == 'transfer completed') {
      this.toast.error('Please select transfer completed status');
      return;
    }
    if (this.isReasonStatus && (this.form.get('reason_id')?.value == null || this.form.get('reason_id')?.value == "")) {
      this.toast.error('Please select reason');
      return;
    }
    if (!this.form.valid) {
      this.validationMessagesService.validateAllFormFields(this.form);
      return;
    }

    this.isLoading = true;

    const payload: {
      id: any;
      reason_id: any;
      courier_id: any;
      user_id: string;
      status: string;
      type: string;
      CustomMessage: boolean;
      Message?: string;
      NotifyUsers: boolean;
      NotifyUsersBy: any;
      internal_notes: any;
      filled_status: any;
    } = {
      id: this.props.item.id,
      reason_id: this.form.value.reason_id,
      courier_id: this.form.value.courier_id,
      user_id: this.props.item.user_id,
      status: this.selectedStatus,
      type: this.props.item.status,
      CustomMessage: this.form.get('custom_message')?.value,
      Message: encodeURIComponent(this.form.get('custom_message')?.value ? this.form.get('message')?.value : ''),
      NotifyUsers: this.form.value.NotifyUsers,
      NotifyUsersBy: this.form.value.NotifyUsersBy?.length > 0 ? this.form.value.NotifyUsersBy.filter((f: any) => f.isChecked).map((m: any) => m.id) : [],
      internal_notes: this.form.value.internal_notes,
      filled_status: this.form.value.filled_status ? this.form.value.filled_status : ''
    };

    this.preAssessmentService.changePrescriptionTrsStatus(payload).subscribe(
      (res) => {
        if (res.body.success) {
          this.toast.success(res.body.message);
          this.dialogRef.close({ payload: payload, response: res.body });
        } else {
          this.toast.error(res.body.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log('error', err);
        this.isLoading = false;
        this.toast.error('An error occurred while updating delivery status.');
      }
    );
  }

  couriersListForPrscriptionStatus() {
    let payload = {
      type: this.props.item.status,
    };
    this.preAssessmentService
      .couriersListForPrscriptionStatus(payload)
      .subscribe((res) => {
        if (res?.body?.success) {
          this.courierList = res?.body?.data;
        } else {
          this.courierList = [];
        }
      });
  }
  openAddCourierDialog() {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = this.props;
    if (window.innerWidth < 768) {
      dialogConfig.width = '90%';
    } else {
      dialogConfig.width = '600px';
    }
    dialogRef = this.dialog.open(
      AddCourierForTransferPrscriptionComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res.response.success) {
        this.couriersListForPrscriptionStatus();
        this.form.controls.courier_id.setValue(res.response.data.id);
      }
    });
  }

  reasonListForPrscriptionStatus() {
    const status = this.selectedStatus;
    const type = (status === 'pending info attempt1' || status === 'pending info attempt2') ? 'transferred pending' : status;
    const payload = {
      type: type,
      reason_from: 1
    };
    this.preAssessmentService
      .reasonListForPrscriptionStatus(payload)
      .subscribe((res) => {
        if (res?.body?.success) {
          this.reasonList = res?.body?.data;
          this.isReasonLoaded = true;
        } else {
          this.reasonList = [];
          this.isReasonLoaded = true;
        }
      });
  }

  openAddRasonDialog() {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    dialogConfig.data = this.props;
    if (window.innerWidth < 768) {
      dialogConfig.width = '90%';
    } else {
      dialogConfig.width = '600px';
    }
    dialogRef = this.dialog.open(AddReasonForTransferPrscription, dialogConfig);
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.response && res.response.success) {
        this.reasonListForPrscriptionStatus();
        this.form.controls.reason_id.setValue(res.response.data.id);
      }
    });
  }

  getCustomeMessage() {
    const status = this.props.item.statusMessage;
    const type = (status === 'pending info attempt1' || status === 'pending info attempt2') ? 'transferred pending' : status;
    const payload = {
      type: type,
      prescription_id: this.props.item.id
    };
    this.preAssessmentService.getCustomeMessage(payload).subscribe((res) => {
      if (res?.body?.success) {
        const customMessage = res?.body?.data?.template ? res?.body?.data?.template : '';
        // Set the value of 'message' field in the form
        this.form.patchValue({
          message: customMessage,
          filled_status: (res?.body?.data?.filled_status != null || res?.body?.data?.filled_status != undefined )? (res.body.data.filled_status).toString() : null
        });
      } else {
        this.form.patchValue({ message: '' });
      }
      this.progress_spinner = false;
    });
  }

  onReasonChange() {
    const payload: any = {
      reason_id: this.form.get('reason_id')?.value,
      item_type: 1,
      type: this.selectedStatus,
      user_id: this.props.item.user_id
    } 
    try {
      this.preAssessmentService.getPatientFacingContent(payload).subscribe((res: any) => {
        if (res.body.success) {
          this.form.get('message')?.setValue(res?.body?.data?.patient_facing_text);
          this.form.get('custom_message')?.setValue(res?.body?.data?.patient_facing_text ? true : false);
          this.form.value.custom_message = true;
          this.form.get('message')?.disable();
          this.form.get('custom_message')?.disable();
          this.isMessageLoaded = true;
          this.isPatientMessage = res?.body?.data?.patient_facing_text ? true : false;
        } else {
          this.toast.error(res.body.message);
        }
      })
    } catch (err) {
      console.log(err)
      this.toast.error('Something went wrong');
    }
  }
}
